export default __webpack_public_path__ + "img/07ed44258e5aeac6b7f503210082edf6.svg";